/*
 * What the Ticket peek decides without a browser: which clicks on a ticket open it.
 */

/** A click on a ticket's link, as far as deciding where it opens. */
export type Click = {
  button: number
  metaKey: boolean
  ctrlKey: boolean
  shiftKey: boolean
  altKey: boolean
  defaultPrevented: boolean
}

/**
 * Whether a click on a ticket opens it in the peek: a plain primary click does. A modifier or a
 * middle click falls through to the link, so the browser opens the full page as it would, and a
 * click something else already took (a drag's last) is left alone.
 */
export function opensPeek(click: Click) {
  return (
    click.button === 0 &&
    !click.defaultPrevented &&
    !click.metaKey &&
    !click.ctrlKey &&
    !click.shiftKey &&
    !click.altKey
  )
}
